const translations = {
  "en": {
    "Convert": "Convert",
    "Have a Gift Code？": "Have a Gift Code？"
  },
  "zh-tw": {
    "Convert": "轉換",
    "Have a Gift Code？": "有兌換碼嗎？"
  }
};

export default translations;
